import { SiteCode } from '@snap-types/models/enums';
import type { Configuration } from '@ui/features/configurator/types';

import { coldHeadedFastenerConfiguration } from './cold-headed-fastener';

type SiteConfiguration = { [key in SiteCode]?: Configuration[] };

export const siteConfigurations: SiteConfiguration = {
  ADF: [coldHeadedFastenerConfiguration],
  ROC: [coldHeadedFastenerConfiguration],
  USA: [],
};
